<template>
  <router-view />
</template>

<style lang="scss">
@import './styles/GlobalStyle.css';
@import './styles/HomeView.css';
@import './styles/DetailsView.css';
@import './styles/CartView.css';
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background-color: #f6f8fc !important;
}
</style>
